module.exports = __webpack_public_path__ + "img/ico-limited.336ea02e.png";